import { Alert, Switch } from 'antd'
import _ from 'lodash'
import Loader from '../../../../Common/Loader'
import { useStepRunState, useStepActions } from '../hooks/useSteps'
import useStepError from '../hooks/useStepError'
import styles from './ExternalDataRetrievalStep.css'
import ExternalErrorStep from './ExternalErrorStep'
import { CAUSE_CODE } from '../constants'

const ExternalDataRetrievalStep = () => {
  const { loadingStep } = useStepRunState()
  const { retryStep } = useStepActions()
  const [stepError] = useStepError()
  const isCorsError = _.get(stepError, 'code') === CAUSE_CODE.EXTERNAL_CLONE_CORS_ERROR

  if (!loadingStep && isCorsError) {
    return (
      <div className={styles.container}>
        <div className={styles.loadingContent}>
          <Alert
            type='warning'
            message='請啟用擴充功能'
            description={(
              <>
                <p>請確認已安裝 Chrome 擴充功能「CORS Unblock」</p>
                <div className={styles.enableRow}>
                  <span>並啟用</span>
                  <Switch
                    readOnly
                    checked
                  />
                  <span>
                    功能後，再
                    <a onClick={() => retryStep()}>重試</a>
                    一次
                  </span>
                </div>
              </>
            )}
            showIcon
          />
        </div>
      </div>
    )
  }

  return (
    <ExternalErrorStep>
      <div className={styles.container}>
        <div className={styles.loadingContent}>
          <Loader
            spinning
            message='取得賣場資料中'
          />
        </div>
      </div>
    </ExternalErrorStep>
  )
}

export default ExternalDataRetrievalStep
